import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from '../../../config/axios';
import { Button } from '../../components/Atoms';
import AuthShell, { AuthError, AuthSuccess } from './AuthShell';

/**
 * VerifyEmail - po kliknięciu w link aktywacyjny z emaila.
 * Backend GET /api/auth/verify-email/:token weryfikuje token i ustawia
 * email_verified=1 w users. Następnie redirect do login.
 */

export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('verifying'); // verifying | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setErrorMsg('Brak tokenu w adresie URL.');
      return;
    }
    axios.get(`/api/auth/verify-email/${token}`)
      .then(() => {
        setState('success');
        setTimeout(() => navigate('/login'), 3000);
      })
      .catch(err => {
        setState('error');
        setErrorMsg(err.response?.data?.error || 'Token nieprawidłowy lub wygasł.');
      });
  }, [token, navigate]);

  if (state === 'verifying') {
    return (
      <AuthShell
        eyebrow="Weryfikacja"
        title="Sprawdzamy link…"
        subtitle="Chwila, weryfikujemy Twoją skrzynkę email."
      >
        <div style={{
          padding: '20px 0', textAlign: 'center',
          fontFamily: 'var(--t-mono)', fontSize: 11,
          letterSpacing: '.18em', textTransform: 'uppercase',
          color: 'var(--t-text-mute)',
        }}>Wczytywanie…</div>
      </AuthShell>
    );
  }

  if (state === 'success') {
    return (
      <AuthShell
        eyebrow="Aktywowano"
        title={<>Email <span style={{ fontStyle: 'italic', color: 'var(--t-sage)' }}>potwierdzony</span>.</>}
        subtitle="Konto jest aktywne. Za chwilę przekierujemy Cię do logowania — albo kliknij poniżej."
        footer={
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <Button>Zaloguj się</Button>
          </Link>
        }
      >
        <AuthSuccess>Witamy w GardenApp.pl. Twój ogród czeka.</AuthSuccess>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      eyebrow="Weryfikacja"
      title={<>Coś <span style={{ fontStyle: 'italic', color: 'var(--t-rust)' }}>nie zadziałało</span>.</>}
      subtitle="Link aktywacyjny jest ważny 24 godziny. Po tym czasie wyślij sobie nowy z poziomu logowania."
      footer={
        <div style={{ fontSize: 13, color: 'var(--t-text-dim)', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Link to="/login" style={{
            color: 'var(--t-sage)', textDecoration: 'none', fontWeight: 500,
          }}>← Wróć do logowania</Link>
          <span>Po zalogowaniu wyślemy nowy link weryfikacyjny.</span>
        </div>
      }
    >
      <AuthError>{errorMsg}</AuthError>
    </AuthShell>
  );
}
